// extracted by mini-css-extract-plugin
export default {"Textarea":"IPTextarea_Textarea__zCWOL"};